<script setup lang="ts">
// The picture on 我能帮你做's first card (网站接入): a site's card over
// another, its CNAME in place and checked — light, in the assistant's
// violet, half out of the card's corner as the clouds draw theirs.
</script>

<template>
  <svg class="action-art" width="132" height="76" viewBox="0 0 132 76" aria-hidden="true">
    <rect x="44" y="6" width="80" height="58" rx="7" class="back" transform="rotate(-7 84 35)" />
    <rect x="24" y="16" width="90" height="62" rx="7" class="front" />
    <text x="35" y="36" class="label">CNAME</text>
    <rect x="35" y="44" width="54" height="5" rx="2.5" class="bar" />
    <rect x="35" y="54" width="34" height="5" rx="2.5" class="bar soft" />
    <circle cx="101" cy="31" r="7.5" class="chip" />
    <path d="M97.6 31.2l2.3 2.3 4-4.4" class="tick" />
  </svg>
</template>

<style scoped>
.action-art {
  display: block;
}
.back {
  fill: rgba(138, 92, 255, 0.12);
}
.front {
  fill: var(--color-bg-2);
  stroke: rgba(138, 92, 255, 0.22);
}
.label {
  fill: #5b45d6;
  font-size: 10px;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif;
  letter-spacing: 0.3px;
}
.bar {
  fill: rgba(111, 92, 255, 0.32);
}
.bar.soft {
  fill: rgba(111, 92, 255, 0.16);
}
.chip {
  fill: rgba(111, 92, 255, 0.14);
}
.tick {
  fill: none;
  stroke: #6f5cff;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
/* Not :global(…) .label — a scoped block drops the part after it. */
body[arco-theme='dark'] .label {
  fill: #b9adff;
}
body[arco-theme='dark'] .tick {
  stroke: #a796ff;
}
</style>
